import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  childrenMenuPage: [],
  activekey: ''
}

const mutations = {
  update(state, payload) {
    console.log('payload', payload)
    for (const key in payload) {
      Vue.set(state, key, payload[key])
    }
  }
}
const actions = {
  upPage({ commit, dispath }, page) {
    console.log('page', page)
    commit('update', page)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
